import { Field, useFormState } from "react-final-form";
import { useIntl } from "react-intl";
import {
  DatePicker,
  DropdownInput,
  SwitchInput,
  TextInput,
} from "../../../common/fields";
import * as Validations from "../../../common/form/validator";

const AssignmentDetailsForm = ({ progarms }) => {
  const formState = useFormState();
  const intl = useIntl();
  return (
    <>
      <div className="grid">
        <div className="col-12 md:col-6 lg:col-4">
          <Field
            name="learning_program"
            component={DropdownInput}
            label={intl.formatMessage({
              id: "learning_program",
            })}
            options={progarms}
            placeholder={intl.formatMessage({
              id: "learning_program",
            })}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
        </div>
      </div>
      <div className="grid">
        <div className="col-12 md:col-6 lg:col-4">
          <Field
            name="is_flexible_date"
            component={SwitchInput}
            type="checkbox"
            label={intl.formatMessage({
              id: "is_date_flexible",
            })}
            placeholder={intl.formatMessage({
              id: "is_date_flexible",
            })}
          />
        </div>
        {(formState?.values?.is_flexible_date && (
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="relative_end_days"
              component={TextInput}
              type="number"
              label={intl.formatMessage({
                id: "relative_end_days",
              })}
              placeholder={intl.formatMessage({
                id: "relative_end_days",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.numberGreater0
              )}
            />
          </div>
        )) ||
          null}
        {(!formState?.values?.is_flexible_date && (
          <>
            <div className="col-12 md:col-6 lg:col-4">
              <Field
                name="start_date"
                component={DatePicker}
                label={intl.formatMessage({
                  id: "start_date",
                })}
                options={[]}
                placeholder={intl.formatMessage({
                  id: "start_date_place_holder",
                })}
                required
                minDate={new Date()}
                validate={Validations.composeValidators(Validations.required)}
              />
            </div>
            <div className="col-12 md:col-6 lg:col-4">
              <Field
                name="end_date"
                component={DatePicker}
                label={intl.formatMessage({
                  id: "end_date",
                })}
                options={[]}
                placeholder={intl.formatMessage({
                  id: "end_date",
                })}
                minDate={formState?.values?.start_date || new Date()}
                validate={Validations.composeValidators(
                  Validations.minDate("start_date")
                )}
              />
            </div>
            <div className="col-12 md:col-6 lg:col-4"></div>
            <div className="col-12 md:col-6 lg:col-4">
              <Field
                name="timezone"
                filter={true}
                component={DropdownInput}
                label={intl.formatMessage({
                  id: "timezone",
                })}
                options={Intl.supportedValuesOf("timeZone").map((item) => ({
                  id: item,
                  name: item,
                }))}
                placeholder={intl.formatMessage({
                  id: "timezone",
                })}
                required
                validate={Validations.composeValidators(Validations.required)}
              />
            </div>
          </>
        )) ||
          null}
      </div>
    </>
  );
};

export default AssignmentDetailsForm;
